var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4667653E-9293-48B0-812F-2FCB4360996B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Share-Modal",
    transform: "translate(-921.000000, -451.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(682.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(239.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#007AB9",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,42.7481011 L63,59 L53.352929,59 L53.352929,43.8372762 C53.352929,40.030082 51.9600787,37.4301154 48.4671612,37.4301154 C45.8016084,37.4301154 44.2181045,39.1805253 43.5188016,40.8754225 C43.2648366,41.4811444 43.1993669,42.3222687 43.1993669,43.1718253 L43.1993669,58.9992973 L33.5515764,58.9992973 C33.5515764,58.9992973 33.6810769,33.3186548 33.5515764,30.6603647 L43.2000863,30.6603647 L43.2000863,34.676259 C43.1806613,34.7078802 43.1533222,34.7387987 43.1360555,34.7690146 L43.2000863,34.7690146 L43.2000863,34.676259 C44.4821417,32.749473 46.7685458,29.9949138 51.8946089,29.9949138 C58.2415745,29.9949138 63,34.0452401 63,42.7481011 L63,42.7481011 Z M23.4591674,17 C20.1590618,17 18,19.1158106 18,21.8956667 C18,24.6164966 20.0964699,26.7934415 23.3325446,26.7934415 L23.3951365,26.7934415 C26.7599923,26.7934415 28.8521456,24.6164966 28.8521456,21.8956667 C28.7881147,19.1158106 26.7599923,17 23.4591674,17 L23.4591674,17 Z M18.5733996,59 L28.2175929,59 L28.2175929,30.6603647 L18.5733996,30.6603647 L18.5733996,59 Z",
    id: "Shape",
    fill: "#F1F2F2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e917413ffca00aaaec5b23343dd4eccf.svg";
export { ForwardRef as ReactComponent };